import { Component, OnInit } from '@angular/core';
import { mainState } from 'src/app/state/app.reducer'
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Message, getMessages } from 'src/app/common/messages';
import { removeMessage } from 'src/app/state/app.actions';
import { animate, sequence, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    animations: [
        trigger('anim', [
            transition('* => void', [
                style({ height: '*', opacity: '1', transform: 'translateX(0)', 'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)' }),
                sequence([
                    animate(".25s ease", style({ height: '*', opacity: '.2', transform: 'translateX(20px)', 'box-shadow': 'none' })),
                    animate(".1s ease", style({ height: '0', opacity: 0, transform: 'translateX(20px)', 'box-shadow': 'none' }))
                ])
            ]),
            transition('void => *', [
                style({ height: '0', opacity: '0', transform: 'translateX(20px)', 'box-shadow': 'none' }),
                sequence([
                    animate(".1s ease", style({ height: '*', opacity: '.2', transform: 'translateX(20px)', 'box-shadow': 'none' })),
                    animate(".35s ease", style({ height: '*', opacity: 1, transform: 'translateX(0)', 'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)' }))
                ])
            ])
        ])
    ],
    standalone: false
})
export class MessagesComponent implements OnInit {
  messages$: Observable<Message[]>;

  constructor(private store: Store<mainState>) {
    this.messages$ = this.store.select(getMessages);
  }

  ngOnInit(): void { }

  remove(message: Message) {
    this.store.dispatch(removeMessage({ message: message }));
  }
}

